<template>
    <v-app-bar>
        <v-toolbar-title v-if="isLoggedIn">Agenda de <strong>{{ username }}</strong></v-toolbar-title>
        <v-spacer></v-spacer>
        <therapist v-on:changedTherapist="changedTherapist" v-if="isLoggedIn && this.$store.getters.isActive"/>
        <v-btn to="/login" v-if="!isLoggedIn">Login</v-btn>
        <v-spacer></v-spacer>
        <v-btn v-if="isLoggedIn" @click="logUserOut">
            <v-icon color="red">mdi-logout</v-icon>
        </v-btn>
    </v-app-bar>
</template>
<script>

import therapist from "@/components/Therapist.vue";

export default {
    components: {
        therapist,
    },
    data() {
        return {};
    },
    methods: {
        changedTherapist() {
            //console.log("changedTherapist NavBar.vue")
            this.$root.$emit('changedTherapist');
        },
        logUserOut() {
            this.$store.dispatch('logout');
            this.$router.push("/login");
        }
    },
    computed: {
        isLoggedIn() {
            return this.$store.getters.isAuthenticated;
        },
        username() {
            return this.$store.getters.userName;
        },
    },
};
</script>
